import { useContext } from 'react'
import { LoaderContext } from '../providers'

export const usePageLoader = () => {
  return useContext(LoaderContext)
}
